import classnames from "classnames";
import * as React from "react";

import styles from "./RegionOption.module.scss";

type Props = {
  name: string;
  flagImg: string;
  clickHandler: () => Promise<void>;
  selected: boolean;
};

export default function RegionOption({
  name,
  flagImg,
  clickHandler,
  selected
}: Props) {
  return (
    <div
      className={classnames(styles.wrapper, {
        [styles.selected]: selected
      })}
      onClick={selected ? undefined : clickHandler}
      data-notranslate
    >
      <img src={flagImg} alt="" className={styles.flag} />
      <span>{name}</span>
    </div>
  );
}
